const INVESTMENTS_SELECTED_ROUTES = [
  { path: "/investments/*" },
  { path: "/watchlists/*" },
  { path: "/classifications" },
  { path: "/new-transaction-wizard" },
  { path: "/manual-transaction-wizard" },
  { path: "/edit-transaction-wizard/*" },
  { path: "/add-transaction-wizard/*" },
  { path: "/dividend-planner" },
];

const CASHFLOW_ANALYZER_PATHS = ["/cashflow-analyzer", "/contract-analyzer"];

const CASHBACK_PATHS = [
  "/cashback",
  "/cashback-import",
  "/cashback/invite-friend",
];

const DEPOTS_ACCOUNTS_ROUTES = [
  { path: "/depots-accounts/*" },
  { path: "/depots/*" },
  { path: "/accounts/*" },
];

const GOALS_ROUTES = [{ path: "/goals/*" }];

export {
  INVESTMENTS_SELECTED_ROUTES,
  CASHFLOW_ANALYZER_PATHS,
  CASHBACK_PATHS,
  DEPOTS_ACCOUNTS_ROUTES,
  GOALS_ROUTES,
};
